/**
 * The type of the sender of the invite
 */
export enum InviteSenderType {
  /**
   * Send an invite as the Sioslife System.
   */
  System = 'system',

  /**
   * Send an invite as an Entity.
   */
  Entity = 'entity',

  /**
   * Send an invite as a Caregiver.
   */
  Caregiver = 'caregiver',

  /**
   * Send an invite as a Senior.
   */
  Senior = 'senior',
}
